@media (min-width: 576px) {
  div.notification-login-QR,
  div.notification-login-EOTP {
    min-height: 106px;
  }
}

.cursor-pointer {
  cursor: pointer;
}
